import React from "react";
import Slider from "@mui/material/Slider";
import PlayerSuper from "./PlayerSuper";
import "./PlayerSuperExtended.css";
import {
    ButtonHistory,
    ButtonPlayPause,
    ButtonQuality,
    ButtonShare,
    ButtonSpeaker,
    CustomReactPlayer,
    Extend, HistoryExtended,
    Image, NumberListener, OverlayHistory,
    OverlayPlay,
    OverlayQuality,
    OverlayShare, Skeleton,
    Timeline, updatePlayerRatio,
    WithoutLogoClassStyle
} from "../../helpers/rendererHelper";
import {getContrastingColor, isColorClose} from "../../helpers/colorHelper";


export default class PlayerSuperExtended extends PlayerSuper {
    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            bufferDuration,
            bufferPreviewed,
            configUrl,
            defaultVolume,
            display,
            embedEnable,
            facebook,
            fragment,
            historyHold,
            historyDisplay,
            isHistoryTimeDisplay,
            isHistoryClickable,
            isHlsBuffered,
            isDirectControl,
            isLoading,
            light,
            listenerHold,
            logo,
            main,
            muted,
            neverPlayed,
            onChangeCommittedFlush,
            playbackRate,
            stationIndex,
            stations,
            playing,
            playlist,
            previousPlayTime,
            secondaryColor,
            stream,
            streams,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            timeline,
            timelineLoaded,
            twitter,
            twitterHashtags,
            twitterAccount,
            preview,
            error,
            numberListener,
            displayListener,
        } = this.state;

        const showPlayer = !!stream;
        const color = {backgroundColor: backgroundColor, color: secondaryColor};

        document.body.style.backgroundColor = backgroundColor;

        if (historyDisplay === 'under') {
            updatePlayerRatio(1.5785, 1);
        } else {
            updatePlayerRatio(1, 1);
        }

        return <>
            <Skeleton hidden={showPlayer}></Skeleton>

            {showPlayer &&
                <>
                    <div className='player-wrapper super-extended-player' style={color}>
                        <OverlayQuality addTitle={true} streams={streams} stream={stream} main={main}
                                        translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                        onClickClose={this.handleCloseOverlay}
                                        load={this.load}/>
                        <OverlayShare embedEnable={embedEnable} facebook={facebook} twitter={twitter}
                                      twitterHashtags={twitterHashtags} twitterAccount={twitterAccount}
                                      translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                                      onClickClose={this.handleCloseOverlay}/>
                        <div id="player-image">
                            <div id='playername'
                                 style={{backgroundColor: backgroundColor + "80"}}>{stations[stationIndex].name}</div>
                            <OverlayPlay onClickPlay={this.handlePlay} onClickPause={this.handlePause} buttonColor={buttonColor} playing={playing}
                                         backgroundColor={backgroundColor} neverPlayed={neverPlayed}/>
                            <Image display={display} onLoad={this.onLoadImage} color={secondaryColor} buttonColor={buttonColor}
                                   neverPlayed={neverPlayed} translations={translations}/>
                            <Timeline
                                fragment={fragment}
                                playlist={playlist}
                                bufferSize={bufferDuration}
                                previousPlayTime={previousPlayTime}
                                neverPlayed={neverPlayed}
                                player={this.player}
                                isHlsBuffered={isHlsBuffered}
                                isDirectControl={isDirectControl}
                                bufferPreviewed={bufferPreviewed}
                                onChangeCommittedFlush={onChangeCommittedFlush}
                                onChange={this.handleSeekTo}
                                streamFormat={stream.format}
                                onAirLabel={translations.onair}
                                secondaryColor={secondaryColor}
                                buttonColor={buttonColor}
                                isLoading={this?.player?.player?.isLoading}
                            />
                        </div>
                        <Extend onClick={this.handleChangeStation}
                                stations={stations}
                                streams={streams}
                                configUrl={configUrl}
                                buttonColor={buttonColor}
                                backgroundColor={backgroundColor}/>
                        <OverlayHistory visible={historyDisplay === 'overlay'} timeline={timeline} historyHold={historyHold}
                                        timeColor={secondaryColor} isDirectControl={isDirectControl} currentTrack={title}
                                        backgroundColor={backgroundColor} currentTime={previousPlayTime} playing={playing}
                                        buttonColor={buttonColor} preview={preview} streamFormat={stream?.format} bufferSize={bufferDuration}
                                        showTimecode={isHistoryTimeDisplay} allowTimeshift={isHistoryClickable} timelineLoaded={timelineLoaded}
                                        onClickClose={this.handleCloseOverlay} onClick={this.handleSeekTo} isHlsBuffered={isHlsBuffered}
                                        fragment={fragment} playlist={playlist} type="overlay"/>
                        <div id="player">
                            <div className="col-left">
                                <div id="title-container" className="text-fade"><p id="title">{title}</p></div>
                                <div id="author-container" className="text-fade"><p id="author">{author}</p></div>
                                <NumberListener numberListener={numberListener} displayListener={displayListener}
                                                error={error} preview={preview} color={secondaryColor} listenerHold={listenerHold}/>
                            </div>
                            <div className={WithoutLogoClassStyle(logo, "col-right")}>
                                <div id="player-buttons" className="buttons">
                                    <ButtonPlayPause
                                        onClickPlay={this.handlePlay}
                                        onClickPause={this.handlePause}
                                        color={buttonColor}
                                        playing={playing}
                                    />
                                    <div className="volume-button-slider-container">
                                        <ButtonSpeaker
                                            onClick={this.handleToggleMuted}
                                            color={buttonColor}
                                            muted={muted}
                                        />
                                        <div id="volume-container">
                                            <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                                    style={{color: isColorClose(buttonColor, '#383838') ? getContrastingColor(buttonColor, backgroundColor) : buttonColor}}
                                                    defaultValue={defaultVolume}
                                                    id="volume" orientation="vertical"
                                                    onChange={this.handleVolumeChange}/>

                                        </div>
                                    </div>

                                    <ButtonQuality
                                        visible={streams.length > 1}
                                        color={buttonColor}
                                        onClick={this.handleToggleOverlay}
                                    />

                                    <ButtonShare
                                        visible={embedEnable || facebook || twitter}
                                        color={buttonColor}
                                        onClick={this.handleToggleOverlay}
                                    />

                                    <ButtonHistory visible={historyDisplay === 'overlay'} color={buttonColor} onClick={this.handleToggleOverlay}/>
                                </div>
                                <a id="logo" target="_blank" href="https://infomaniak.com">
                                    <p id="powered-by">powered by</p>
                                    <p id="infomaniak">infomaniak</p>
                                </a>
                            </div>
                        </div>
                        <CustomReactPlayer
                            myRef={this.ref}
                            url={url}
                            playing={playing}
                            light={light}
                            playbackRate={playbackRate}
                            volume={volume}
                            muted={muted}
                            neverPlayed={neverPlayed}
                            playlist={playlist}
                            fragment={fragment}
                            unavailableUrl={unavailableUrl}
                            onReady={this.onPlayerReady}
                            onProgress={this.handleProgress}
                            onPlay={this.handleOnPlay}
                            setPlayerInError={this.setPlayerInError}
                            preview={preview}
                            isHlsBuffered={isHlsBuffered}
                            isDirectControl={isDirectControl}
                        />
                    </div>

                    {historyDisplay === 'under' &&
                        <HistoryExtended timeline={timeline} timeColor={secondaryColor}
                                         textColor={buttonColor} isDirectControl={isDirectControl}
                                         currentTrack={title} streamFormat={stream?.format}
                                         backgroundColor={backgroundColor} historyHold={historyHold}
                                         currentTime={previousPlayTime} historyDisplay={historyDisplay}
                                         isHlsBuffered={isHlsBuffered} timelineLoaded={timelineLoaded}
                                         fragment={fragment} playlist={playlist}
                                         onClick={this.handleSeekTo} type="extended" preview={preview}
                                         showTimecode={isHistoryTimeDisplay}
                                         bufferSize={bufferDuration}
                                         allowTimeshift={isHistoryClickable} playing={playing}/>
                    }
                </>
            }
        </>;
    }
}
